import {
  AUTO_FILL_COMPANY_EMAIL,
  AUTO_FILL_FILLS_PER_LEVEL,
  AUTO_FILL_MAX_LEVEL,
  getLevelAmount,
  getLevelPaymentTotals,
} from "../../config/autoFillProgramConfig";

export function buildMatrixPlanReferenceRows() {
  const rows = [];
  let cumulativeCo = 0;
  for (let level = 1; level <= AUTO_FILL_MAX_LEVEL; level += 1) {
    const autoFill = getLevelAmount(level);
    const totals = getLevelPaymentTotals(level);
    const isLast = level === AUTO_FILL_MAX_LEVEL;
    const autoUpgrade = isLast ? 0 : totals.upgradePool;
    const coPoints = isLast ? totals.threePayments : totals.pointsWallet;
    cumulativeCo += coPoints;
    rows.push({
      level,
      autoFill,
      fillCount: AUTO_FILL_FILLS_PER_LEVEL,
      total: totals.threePayments,
      autoUpgrade,
      coPoints,
      cumulativeCo,
      autoUpgradeLabel: isLast ? "NO Upgrade" : autoUpgrade,
    });
  }
  return rows;
}

export function aggregateAutoFillMetrics({
  ledgerRows,
  users,
  withdrawals,
  companyUser,
  programs = [],
}) {
  let totalMatrixVolume = 0;
  let ledgerCoPoints = 0;
  let ledgerUpgrade = 0;
  let ledgerProgramCreated = 0;
  let ledgerLevelActivated = 0;
  let legacyMemberPoints = 0;

  ledgerRows.forEach((row) => {
    const amt = Number(row.amount) || 0;
    if (row.transactionType === "CO_POINTS") {
      ledgerCoPoints += amt;
      totalMatrixVolume += amt;
    } else if (row.transactionType === "LEVEL_UPGRADE") {
      ledgerUpgrade += amt;
      totalMatrixVolume += amt;
    } else if (row.transactionType === "POINTS") {
      legacyMemberPoints += amt;
      totalMatrixVolume += amt;
    } else if (row.transactionType === "PROGRAM_CREATED") {
      ledgerProgramCreated += amt;
    } else if (row.transactionType === "LEVEL_ACTIVATED") {
      ledgerLevelActivated += amt;
    }
  });

  let enrollmentFromPrograms = 0;
  let programsAt150 = 0;
  let programsExcludedNon150 = 0;
  programs.forEach((p) => {
    const amt = Number(p.packageAmount) || 0;
    if (amt !== 150) {
      programsExcludedNon150 += 1;
      return;
    }
    enrollmentFromPrograms += amt;
    programsAt150 += 1;
  });

  let upgradeOnHold = 0;
  let upgradeUsed = 0;
  let memberPointsAvailable = 0;
  let memberPointsEarned = 0;
  let memberPointsLocked = 0;
  let memberPointsWithdrawn = 0;
  let membersWithPointsBalance = 0;
  users.forEach((u) => {
    upgradeOnHold += u.autoFillUpgrade?.reserved || 0;
    upgradeUsed += u.autoFillUpgrade?.used || 0;
    const pts = u.autoFillPoints || {};
    memberPointsAvailable += pts.available || 0;
    memberPointsEarned += pts.earned || 0;
    memberPointsLocked += pts.locked || 0;
    memberPointsWithdrawn += pts.withdrawn || 0;
    if ((pts.available || 0) > 0 || (pts.earned || 0) > 0) {
      membersWithPointsBalance += 1;
    }
  });

  const adminCo = companyUser?.autoFillCoPoints || {};
  const adminCoEarned = Number(adminCo.earned) || 0;
  const adminCoAvailable = Number(adminCo.available) || 0;

  let withdrawalCompleted = 0;
  let withdrawalPending = 0;
  withdrawals.forEach((w) => {
    const amt = Number(w.amount) || 0;
    if (w.status === "COMPLETED") withdrawalCompleted += amt;
    if (w.status === "PENDING") withdrawalPending += amt;
  });

  const enrollmentVolume =
    ledgerProgramCreated > 0 ? ledgerProgramCreated : enrollmentFromPrograms;

  return {
    programCount: programs.length,
    programsAt150,
    programsExcludedNon150,
    enrollmentVolume,
    ledgerProgramCreated,
    totalMatrixVolume,
    totalPlatformInflow: enrollmentVolume + totalMatrixVolume,
    ledgerCoPointsTotal: ledgerCoPoints,
    ledgerLevelActivated,
    companyCoPointsEarned:
      adminCoEarned > 0 ? adminCoEarned : ledgerCoPoints,
    companyCoPointsAvailable:
      adminCoAvailable > 0 ? adminCoAvailable : adminCoEarned || ledgerCoPoints,
    memberCoPointsWalletAvailable: memberPointsAvailable,
    memberPointsEarnedTotal: memberPointsEarned,
    memberPointsLockedTotal: memberPointsLocked,
    memberPointsWithdrawnTotal: memberPointsWithdrawn,
    membersWithPointsBalance,
    legacyMemberPointsFromOldEngine: legacyMemberPoints,
    /** Current upgrade pool not yet applied to a level-up */
    upgradeOnHold,
    /** Already consumed for LEVEL_ACTIVATED */
    upgradeUsedTotal: upgradeUsed,
    ledgerUpgradeCredits: ledgerUpgrade,
    memberPointsWalletAvailable: memberPointsAvailable,
    withdrawalCompleted,
    withdrawalPending,
    companyEmail: AUTO_FILL_COMPANY_EMAIL,
    planGrandTotalCo: buildMatrixPlanReferenceRows().reduce(
      (s, r) => s + r.coPoints,
      0
    ),
    planFullCycleFillVolume: buildMatrixPlanReferenceRows().reduce(
      (s, r) => s + r.total,
      0
    ),
  };
}
